import { ClientJourneyValidationMetadata } from 'src/app/client/journey/shared/validation/client-journey-validation-metadata';
import { ModelValidator } from 'src/app/client/journey/shared/validation/model-validator';
import { PepDisclosureModel } from '../../submit/pepModel.model';
import { isStringNullOrEmpty } from 'src/shared-utilities/string-helpers';
import { PureDate } from 'src/shared-utilities/models/pureDate';
import { isNullOrUndefined } from 'src/shared-utilities/utilities';
import { isNull } from '@uirouter/core';

export enum PepValidationRules {
  IsPep = 'isPep',
  FirstName = 'firstName',
  LastName = 'lastName',
  PepStatus = 'pepStatus',
  PepPosition = 'pepPosition',
  PepRelationship = 'pepRelationship',
  PepOrganizationName = 'pepOrganizationName',
  PositionCountry = 'positionCountry',
  PositionTitle = 'positionTitle',
  IsActivePosition = 'isActivePosition',
  IsProvidingFunding = 'isProvidingFunding',
  SourceOfFunds = 'sourceOfFunds',
  DatePositionStart = 'datePositionStart',
  DatePositionEnd = 'datePositionEnd',
}

export class PepValidator extends ModelValidator<PepDisclosureModel, ClientJourneyValidationMetadata> {
  constructor(model: PepDisclosureModel) {
    super(model);

    const navigationMetadata = {
      blocksNavigation: false,
      showInMenu: true,
    } as ClientJourneyValidationMetadata;

    const validateDateFn = function validateDate(date: PureDate): boolean {
      if (date) {
        return date.isValid();
      }
      return false;
    };

    this.ruleFor(m => m.isPep, PepValidationRules.IsPep, navigationMetadata)
      .when(m => m.isInitialized === true)
      .must(isPep => !isNullOrUndefined(isPep));

    this.ruleFor(m => m.firstName, PepValidationRules.FirstName, navigationMetadata)
      .when(m => m.isPep === true)
      .must(firstName => !isStringNullOrEmpty(firstName, true));

    this.ruleFor(m => m.lastName, PepValidationRules.LastName, navigationMetadata)
      .when(m => m.isPep === true)
      .must(lastName => !isStringNullOrEmpty(lastName, true));

    this.ruleFor(m => m.pepStatus, PepValidationRules.PepStatus, navigationMetadata)
      .when(m => m.isPep === true)
      .must(pepStatus => !isNullOrUndefined(pepStatus));

    this.ruleFor(m => m.pepPosition, PepValidationRules.PepPosition, navigationMetadata)
      .when(m => m.isPep === true)
      .must(pepPosition => !isNullOrUndefined(pepPosition));

    this.ruleFor(m => m.pepRelationship, PepValidationRules.PepRelationship, navigationMetadata)
      .when(m => m.isPep === true)
      .must(pepRelationship => !isNullOrUndefined(pepRelationship));

    this.ruleFor(m => m.organizationName, PepValidationRules.PepOrganizationName, navigationMetadata)
      .when(m => m.isPep === true)
      .must(pepOrganizationName => !isStringNullOrEmpty(pepOrganizationName, true));

    this.ruleFor(m => m.positionCountry, PepValidationRules.PositionCountry, navigationMetadata)
      .when(m => m.isPep === true)
      .must(positionCountry => !isStringNullOrEmpty(positionCountry, true));

    this.ruleFor(m => m.positionTitle, PepValidationRules.PositionTitle, navigationMetadata)
      .when(m => m.isPep === true)
      .must(positionTitle => !isStringNullOrEmpty(positionTitle, true));

    this.ruleFor(m => m.isActivePosition, PepValidationRules.IsActivePosition, navigationMetadata)
      .when(m => m.isPep === true)
      .must(isActivePosition => !isNullOrUndefined(isActivePosition));

    this.ruleFor(m => m.isProvidingFunding, PepValidationRules.IsProvidingFunding, navigationMetadata)
      .when(m => m.isPep === true)
      .must(isProvidingFunding => !isNullOrUndefined(isProvidingFunding));

    this.ruleFor(m => m.sourceOfFunds, PepValidationRules.SourceOfFunds, navigationMetadata)
      .when(m => m.isPep === true && !isNullOrUndefined(m.isProvidingFunding) && m.isProvidingFunding === true)
      .must(sourceOfFunds => !isStringNullOrEmpty(sourceOfFunds, true));

    this.ruleFor(m => m.datePositionStart, PepValidationRules.DatePositionStart, navigationMetadata)
      .when(m => m.isPep === true)
      .must(datePositionStart => datePositionStart != null && validateDateFn(datePositionStart));

    this.ruleFor(m => m.datePositionEnd, PepValidationRules.DatePositionEnd, navigationMetadata)
      .when(m => m.isPep == true && m.isActivePosition != null && m.isActivePosition == false)
      .must(datePositionEnd => {
        console.log('is active position', this.model.isActivePosition);
        console.log('datePositionEnd', datePositionEnd);
        return datePositionEnd != null && validateDateFn(datePositionEnd);
      });
  }
}
